import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDoubleArrowLeftIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M8.50838 13.7249C8.82123 14.0372 8.82123 14.4535 8.50838 14.7658C8.19553 15.0781 7.7784 15.0781 7.46555 14.7658L1.20857 8.52045C1.10428 8.41636 1 8.20818 1 8C1 7.79182 1.10428 7.58364 1.20857 7.47955L7.46555 1.2342C7.7784 0.921933 8.19553 0.921933 8.50838 1.2342C8.82123 1.54647 8.82123 1.96283 8.50838 2.27509L2.77281 8L8.50838 13.7249ZM9.02979 8L14.7654 2.27509C15.0782 1.96283 15.0782 1.54647 14.7654 1.2342C14.4525 0.921933 14.0354 0.921933 13.7225 1.2342L7.46555 7.47955C7.36127 7.58364 7.25698 7.79182 7.25698 8C7.25698 8.20818 7.36127 8.41636 7.46555 8.52045L13.7225 14.7658C14.0354 15.0781 14.4525 15.0781 14.7654 14.7658C15.0782 14.4535 15.0782 14.0372 14.7654 13.7249L9.02979 8Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrDoubleArrowLeftIconComponent;
